<template>
	<div class="audio-box" v-show="status==1 || status == 2" @click.stop>
        <span class="avatar" :class="{'rotate' : status==1}" ></span>
        <span class="btn" v-show="status != 1" @click.stop="play"></span>
        <span class="btn btn-pause" v-show="status == 1"  @click.stop="pause"></span>
        <span class="btn-stop" @click.stop="stop"></span>
	</div>
</template>

<script>
	export default {
		data() {
			return {
                audio : null,
                src : null, //当前播放的音频
                status : 3, // 0:stop,1:play,2:pause 3：未加载
                hashCode : ''
			}
		},
		methods: {
            pause : function(){
                this.status = 2;
                this.audio.pause();
                console.log('pause')
                var endTime = new Date().getTime();
                var readTime = Math.floor((endTime - this.startTime) / 1000);

                this.$bus.$emit("closePreview", {
                    readTime    : readTime,
                    res         : this.res
                });
            },
            play : function(res){//播放资源时记录当前资源
                var u = navigator.userAgent, app = navigator.appVersion;
                var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
                
                if(this.audio.readyState != 4){
                    if (isIOS) {　　　　    //这个是ios操作系统
                        this.audio.play();  //兼容ios系统必修手动播放音频的问题
                    }
                    this.loading = weui.loading('正在加载音频');
                    setTimeout(function(){
                        this.loading,hide()
                    }, 15000);
                    return;
                }
                if(this.loading){
                    this.loading.hide();
                }
                this.audio.play();
                this.status = 1;
            },
            stop : function(){
                this.status = 0;
                this.audio.pause();
                this.audio.currentTime = 0;
               	$('body').append($('.audio-box'));
            },
            getOffsetTop : function(el){
                return el.offsetParent ? el.offsetTop + this.getOffsetTop(el.offsetParent) : el.offsetTop
            },
			playAudio: function(url){
                if(!url){
                    return;
                }
                var hashCode = this.getHashCode(url);
                if(hashCode != this.hashCode && this.audio){
                    this.stop();
                    this.hashCode = hashCode;
                }
                
                var $audio = $('#audio_' + hashCode);
                if($audio.length > 0){
                    this.audio = $audio[0];
                }

                if(this.audio.error){
                    return weui.toast('音频文件不存在', {duration: 1000, className : 'sc-warn-toast'});
                }

                this.initEvent();

                var $li = $audio.parent('.gallery-item');
                var li = $li[0];
                // var top = this.getOffsetTop(li);
                var top = 0;
                var left = 0;
                var width = li.offsetWidth;
                var height = li.offsetHeight;
                var style= 'top:' + top + 'px;' + 'left:' + left + 'px;' + 'width:' + width + 'px;' + 'height:' + height + 'px;'
                this.height = height;
                $('.audio-box').attr('style', style);
                $li.append($('.audio-box'));
                return this.play();
            },
			initEvent: function(){
                var _this = this;
                _this.audio.addEventListener('ended', function () {  
                    _this.stop();
                }, false);

                _this.audio.addEventListener("canplaythrough", function () {   //当浏览器预计能够在不停下来进行缓冲的情况下持续播放指定的音频/视频时，会发生 canplaythrough 事件
                    console.log('canplaythrough');
                    // alert('canplaythrough');
                    if(this.loading ){
                        this.loading.hide();
                    }
                    _this.play(); 
                });


                _this.audio.addEventListener("canplay", function () {   //当浏览器预计能够在不停下来进行缓冲的情况下持续播放指定的音频/视频时，会发生 canplaythrough 事件
                    console.log('canplay');
                    // alert('canplay');
                });

                _this.audio.addEventListener("play", function () {   //当浏览器预计能够在不停下来进行缓冲的情况下持续播放指定的音频/视频时，会发生 canplaythrough 事件
                    console.log('play');
                    // alert('play');
                });
			}
        },
        beforeDestroy(){
            this.stop();
        }
	}
</script>

<style scoped>
.audio-box{
    position: absolute;
    z-index: 10;
    background-color: rgba(0, 0, 0, 0.9);
    /* background-color: rgba(255, 255, 255, 0.9); */
    /* border: 2px solid rgba(0, 0, 0, 0.5); */
    text-align: center;
}

.audio-box span{
    height: 100%;
    width: 1.3rem;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: .9rem .9rem;
}
.audio-box .avatar{
    float: left;
    background-image: url('../../static/svg/audio.svg');
}

.audio-box .btn{
    float: none;
    display: inline-block;
    background-image: url('../../static/svg/play.svg');
}


.audio-box .btn-pause{
    background-image: url('../../static/svg/pause.svg');
}


.audio-box .btn-stop{
    float: right;
    background-image: url('../../static/svg/stop.svg');
}


.rotate {
    -webkit-animation: rotating 1.2s linear infinite;
    -moz-animation: rotating 1.2s linear infinite;
    -o-animation: rotating 1.2s linear infinite;
    animation: rotating 1.2s linear infinite;
}

</style>


// WEBPACK FOOTER //
// src/plugins/audio.vue